var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.1875C22 3.42709 20.5729 2 18.8125 2H9.1875C7.42709 2 6 3.42709 6 5.1875V6H5.1875C3.42709 6 2 7.42709 2 9.1875V18.8125C2 20.5729 3.42709 22 5.1875 22H14.8125C16.5729 22 18 20.5729 18 18.8125V18H18.8125C20.5729 18 22 16.5729 22 14.8125V5.1875ZM18 15.875H18.8125C19.3993 15.875 19.875 15.3993 19.875 14.8125V5.1875C19.875 4.6007 19.3993 4.125 18.8125 4.125H9.1875C8.6007 4.125 8.125 4.6007 8.125 5.1875L8.12455 6H14.8125C16.5729 6 18 7.42709 18 9.1875V15.875ZM5.1875 8.125C4.6007 8.125 4.125 8.6007 4.125 9.1875V18.8125C4.125 19.3993 4.6007 19.875 5.1875 19.875H14.8125C15.3993 19.875 15.875 19.3993 15.875 18.8125V9.1875C15.875 8.6007 15.3993 8.125 14.8125 8.125H5.1875Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCopy.4b37c08c270e8d4fe2fc458fce5ba9a5.svg";